import { actionNames, actionPrefixes } from "@newsela/snitch";

import ExportablesBaseModal from "@/components/AIComponents/ExportablesModal/ExportablesBaseModal";
import { ASSESSMENT_TYPE } from "@/types/models";
import ViewableActivity from "@/view/TeacherActivityContainer/ViewableActivity";
import { useExportablesContext } from "@/components/AIComponents/ExportablesModal/ExportablesContextProvider/useExportablesContext";

const TeacherComponent = ({
  dispatch,
  setVisibleActivityIds,
  visibleActivityIds,
}: {
  dispatch: () => void;
  setVisibleActivityIds: () => void;
  visibleActivityIds: string[];
}) => {
  const {
    content,
    isAssignableGraphicOrganizersActivityChecked,
    levelId,
    setIsAssignableGraphicOrganizersActivityChecked,
    templatesToAssign,
  } = useExportablesContext();

  const hasSelectedGraphicOrganizerToAssign = templatesToAssign.length > 0;

  const checkboxQaSelector = hasSelectedGraphicOrganizerToAssign
    ? "remove-graphic-organizer-activity-from-assignment"
    : "add-graphic-organizer-activity-to-assignment";

  const {
    handleTemplateSelection,
    modalTriggerRef,
    isContentSupported,
    isInAssignGraphicOrganizersExperiment,
  } = useExportablesContext();

  const eventProperties = {
    // TODO: add "GraphicOrganizer" to objectTypes on snitch
    objectType: "GraphicOrganizer",
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.interact,
    ref: modalTriggerRef,
    streamProperties: {
      content_type: content.content_type,
      content_id: levelId,
      description: "Open modal for exportable resources",
    },
  };

  const handleClick = () => {
    handleTemplateSelection();
  };

  if (!isContentSupported || !isInAssignGraphicOrganizersExperiment)
    return null;

  const toggleGraphicOrganizers = (isSelected: boolean) => {
    setIsAssignableGraphicOrganizersActivityChecked(isSelected);

    if (!hasSelectedGraphicOrganizerToAssign) {
      handleTemplateSelection();
    }
  };

  return (
    <>
      <ViewableActivity
        assessmentType={ASSESSMENT_TYPE.GRAPHIC_ORGANIZERS}
        buttonDataProps={{
          "data-qa-selector": "open-exportables-modal-button",
        }}
        checkboxDataProps={{ "data-qa-selector": checkboxQaSelector }}
        dispatch={dispatch}
        isSelected={
          hasSelectedGraphicOrganizerToAssign &&
          isAssignableGraphicOrganizersActivityChecked
        }
        label="Graphic Organizers"
        onClick={handleClick}
        eventProperties={eventProperties}
        setVisibleActivityIds={setVisibleActivityIds}
        visibleActivityIds={visibleActivityIds}
        toggleGraphicOrganizers={toggleGraphicOrganizers}
      />

      <ExportablesBaseModal isStudent={false} />
    </>
  );
};

export default TeacherComponent;
